export const selector = 'dbABlacklist';

/* @ngInject */
export default function BlacklistDirective($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link(scope, element, attrs, ctrl) {
            const getBlacklist = $parse(attrs[selector]);

            ctrl.$parsers.unshift((value) => {
                validate(value);
                return value;
            });

            ctrl.$formatters.unshift((value) => {
                validate(value);
                return value;
            });

            function validate(value) {
                let valid = !exists(value);
                
                ctrl.$setValidity('blacklist', valid);
                
                return valid;
            }

            function exists(value) {
                let list = getBlacklist(scope) || [];
                return list.indexOf(value) >= 0;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/blacklist/blacklist.directive.js